/* ==================== Pre-launch countdown ====================
   Its own IIFE on purpose: the carousel below bails out early when there is
   no viewport or no cards, and the bar must not die with it.

   Both layers guard the phase — Liquid picks it at render time so the first
   paint is right, and this re-derives it from Date.now() every second so a
   page served from Shopify's full-page cache flips itself at launch with no
   reload. */
(function () {
    var root = document.querySelector('.jb-ltd26');
    if (!root) return;
    var startMs = parseInt(root.getAttribute('data-jltd-start'), 10) * 1000;
    if (!isFinite(startMs) || startMs <= 0) return;

    var countEl = root.querySelector('[data-jltd-countdown]');
    var digits = {
      d: root.querySelectorAll('[data-jltd-cd="d"]'),
      h: root.querySelectorAll('[data-jltd-cd="h"]'),
      m: root.querySelectorAll('[data-jltd-cd="m"]'),
      s: root.querySelectorAll('[data-jltd-cd="s"]')
    };
    var tickTimer = null;
    var lastAriaMinute = -1;

    function pad(n) {
      return (n < 10 ? '0' : '') + n;
    }
    function setDigit(key, value) {
      Array.prototype.forEach.call(digits[key], function (el) {
        if (el.textContent !== value) el.textContent = value;
      });
    }

    function tick() {
      var diff = Math.floor((startMs - Date.now()) / 1000);

      if (diff <= 0) {
        // CSS keyed off this attribute hides the bar — no reload needed.
        root.setAttribute('data-jltd-phase', 'live');
        if (tickTimer) {
          clearInterval(tickTimer);
          tickTimer = null;
        }
        return;
      }
      root.setAttribute('data-jltd-phase', 'before');

      var d = Math.floor(diff / 86400);
      var h = Math.floor((diff % 86400) / 3600);
      var m = Math.floor((diff % 3600) / 60);
      setDigit('d', pad(d));
      setDigit('h', pad(h));
      setDigit('m', pad(m));
      setDigit('s', pad(diff % 60));

      // Refresh the timer label at most once per minute (avoids SR spam).
      if (countEl && m !== lastAriaMinute) {
        lastAriaMinute = m;
        countEl.setAttribute(
          'aria-label',
          'Noch ' + d + ' Tage, ' + h + ' Stunden und ' + m + ' Minuten bis zum Launch'
        );
      }
    }

    tick();
    tickTimer = setInterval(tick, 1000);
  })();

/* ==================== Carousel ==================== */
(function () {
    var root = document.querySelector('.jb-ltd26');
    if (!root) return;
    var vp = root.querySelector('#jltd-vp');
    if (!vp) return;
    var track = vp.querySelector('.jltd-track');
    if (!track || !track.children.length) return;

    // Master list in default (server-rendered) order.
    var originals = Array.prototype.slice.call(track.children);
    var state = { count: originals.length };
    var userInteracted = false;

    function markInteracted() { userInteracted = true; }
    vp.addEventListener('pointerdown', markInteracted, { passive: true });
    vp.addEventListener('wheel', markInteracted, { passive: true });
    vp.addEventListener('touchstart', markInteracted, { passive: true });

    function cardWidth() {
      var card = track.children[0];
      if (!card) return 0;
      var styles = getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
      return card.getBoundingClientRect().width + gap;
    }
    function setW() { return cardWidth() * state.count; }
    function trackGapPx() {
      var styles = getComputedStyle(track);
      return parseFloat(styles.columnGap || styles.gap || '0') || 0;
    }
    function leftPeek() {
      if (window.innerWidth < 700) {
        // Mobile: center one card with symmetric small peek on each side.
        return (vp.clientWidth - cardWidth() + trackGapPx()) / 2;
      }
      // Tablet / Desktop: half-card peek.
      return cardWidth() * 0.5;
    }
    function center() {
      var prevBehavior = vp.style.scrollBehavior;
      vp.style.scrollBehavior = 'auto';
      vp.scrollLeft = setW() - leftPeek();
      void vp.offsetWidth;
      vp.style.scrollBehavior = prevBehavior;
    }
    function safeCenter() {
      if (userInteracted) return;
      center();
    }

    function cloneSlide(s) {
      // Clones keep live forms — they submit the same variant as the
      // originals, so the peek cards stay functional.
      var c = s.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.classList.add('is-clone');
      Array.prototype.forEach.call(c.querySelectorAll('a, button, input'), function (el) {
        el.setAttribute('tabindex', '-1');
      });
      return c;
    }

    // Padding duplicates (see mount) land in the primary, visible band — so
    // unlike loop clones they stay focusable and exposed to screen readers.
    function padSlide(s) {
      var c = s.cloneNode(true);
      c.classList.add('is-clone');
      return c;
    }

    // (Re)build the track from an ordered list of original cards and
    // re-create the loop clones around it.
    function mount(list) {
      while (track.firstChild) track.removeChild(track.firstChild);
      list.forEach(function (s) { track.appendChild(s); });

      if (list.length < 2) {
        state.count = list.length;
        userInteracted = false;
        center();
        return;
      }

      // Pad short collections before cloning. settle() treats the track as
      // exactly three sets and wraps on `mid >= 2*setW` / `mid < setW`, which
      // only stays inside the scrollable range while setW >= clientWidth/2.
      // Since cards are now capped at --jltd-card-max, a small collection on
      // a very wide screen falls under that and the loop stops wrapping.
      // Repeating the set until it spans the viewport restores the margin.
      // No extra network cost — the duplicates reuse images already
      // requested. `base` is deliberately local: reassigning `originals`
      // here would corrupt the tab counts on every sort.
      var base = list;
      var pads = 0;
      while (cardWidth() > 0 && cardWidth() * base.length < vp.clientWidth && pads < 3) {
        base.forEach(function (s) { track.appendChild(padSlide(s)); });
        base = Array.prototype.slice.call(track.children);
        pads++;
      }

      state.count = base.length;
      base.forEach(function (s) { track.appendChild(cloneSlide(s)); });
      base.slice().reverse().forEach(function (s) { track.insertBefore(cloneSlide(s), track.firstChild); });
      userInteracted = false;
      center();
      requestAnimationFrame(center);
    }

    // After scrolling stops: (1) jump back into the originals set if the user
    // drifted into a clone region, (2) align the nearest card to the center
    // (JS snapping — CSS scroll-snap would fight the loop jumps).
    var touchActive = false;
    vp.addEventListener('touchstart', function () { touchActive = true; }, { passive: true });
    vp.addEventListener('touchend', function () { touchActive = false; queueSettle(); }, { passive: true });

    function settle() {
      if (state.count < 2) return;
      var sw = setW();
      if (sw === 0) return;
      var sl = vp.scrollLeft;
      var mid = sl + vp.clientWidth / 2;
      if (mid >= 2 * sw) {
        vp.style.scrollBehavior = 'auto';
        sl = sl - sw;
        vp.scrollLeft = sl;
        void vp.offsetWidth;
        vp.style.scrollBehavior = '';
      } else if (mid < sw) {
        vp.style.scrollBehavior = 'auto';
        sl = sl + sw;
        vp.scrollLeft = sl;
        void vp.offsetWidth;
        vp.style.scrollBehavior = '';
      }
      if (touchActive) return;
      var cw = cardWidth();
      if (!cw) return;
      var base = sw - leftPeek();
      var off = (sl - base) % cw;
      if (off < 0) off += cw;
      var delta = off > cw / 2 ? cw - off : -off;
      if (Math.abs(delta) > 2) {
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        vp.scrollTo({ left: sl + delta, behavior: reduce ? 'auto' : 'smooth' });
      }
    }
    var t;
    function queueSettle() {
      clearTimeout(t);
      t = setTimeout(settle, 140);
    }
    vp.addEventListener('scroll', queueSettle, { passive: true });

    function step(dir) {
      markInteracted();
      vp.scrollBy({ left: cardWidth() * dir, behavior: 'smooth' });
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-jltd-prev]'), function (b) {
      b.addEventListener('click', function () { step(-1); });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-jltd-next]'), function (b) {
      b.addEventListener('click', function () { step(1); });
    });

    // Flavor counts in the tab labels (counts every displayed card matching
    // the tag, sold-out included — they remain visible in every sort).
    function countFor(key) {
      if (key === 'alle') return originals.length;
      return originals.filter(function (el) {
        return (el.getAttribute('data-tags') || '').indexOf(key) !== -1;
      }).length;
    }
    Array.prototype.forEach.call(root.querySelectorAll('.jltd-tab'), function (tab) {
      var span = tab.querySelector('.jltd-tab__count');
      if (span) span.textContent = '(' + countFor(tab.getAttribute('data-jltd-sort')) + ')';
    });

    // Sort tabs: re-order, never hide. Sold-out cards always stay last.
    function sortFor(key) {
      if (key === 'alle') return originals.slice();
      var match = [];
      var rest = [];
      var sold = [];
      originals.forEach(function (el) {
        if (el.getAttribute('data-soldout') === 'true') { sold.push(el); return; }
        var tags = el.getAttribute('data-tags') || '';
        if (tags.indexOf(key) !== -1) { match.push(el); } else { rest.push(el); }
      });
      return match.concat(rest, sold);
    }
    Array.prototype.forEach.call(root.querySelectorAll('.jltd-tab'), function (tab) {
      tab.addEventListener('click', function () {
        var key = this.getAttribute('data-jltd-sort');
        Array.prototype.forEach.call(root.querySelectorAll('.jltd-tab'), function (tb) {
          tb.classList.toggle('jltd-tab--active', tb === tab);
        });
        mount(sortFor(key));
      });
    });

    // Initial mount (adds clones + centers).
    mount(originals);
    window.addEventListener('load', function () { requestAnimationFrame(safeCenter); }, { once: true });
    Array.prototype.forEach.call(track.querySelectorAll('li:not(.is-clone) img'), function (img) {
      if (!img.complete) img.addEventListener('load', safeCenter, { once: true });
    });
  })();
